<!-- <div class="th challenge-popup"> -->
  <ion-content class="content_padding">
    <ion-grid class="th challenge-popup">
      <ion-row>
        <ion-col>
            <div class="d-icons">
              <div>
                <img [src]="popupDetails.finding_icon"/>
              </div>
              <ion-icon (click)="closePopup()" name="close-outline"></ion-icon>
            </div>
        </ion-col>
      </ion-row>

      <ion-row class="d-desc">
        <ion-col>
            <div class="title">
              <ion-label>{{popupDetails.title | translate}}</ion-label>
            </div>
            <div>{{popupDetails.description  | translate}}</div>
        </ion-col>
      </ion-row>
  </ion-grid>
</ion-content>
<!-- 
</div> -->